export interface SvgProps extends React.ComponentProps<"svg"> {
  height?: number;
  width?: number;
  /** SVG fill color, defaults to "currentColor" */
  color?: string;
}

export const Close: React.FC<SvgProps> = ({
  height = "10",
  width = "10",
  color,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      id="close"
      d="M9.74785 1.31915C10.0496 1.01737 10.0496 0.528102 9.74785 0.226329C9.44607 -0.0754433 8.9568 -0.0754431 8.65503 0.22633L5.26629 3.61507C5.12438 3.75698 4.8943 3.75698 4.75239 3.61507L1.36785 0.230531C1.06376 -0.0735626 0.570729 -0.0735623 0.266636 0.230531L0.22807 0.269097C-0.0760235 0.57319 -0.0760232 1.06622 0.22807 1.37032L3.61261 4.75485C3.75452 4.89676 3.75452 5.12684 3.61261 5.26875L0.242553 8.63881C-0.0592196 8.94058 -0.0592194 9.42985 0.242554 9.73162C0.544326 10.0334 1.0336 10.0334 1.33537 9.73162L4.70542 6.36157C4.84733 6.21966 5.07741 6.21966 5.21932 6.36157L8.63214 9.77439C8.93624 10.0785 9.42927 10.0785 9.73336 9.77439L9.77193 9.73582C10.076 9.43173 10.076 8.9387 9.77193 8.63461L6.35911 5.22179C6.2172 5.07987 6.2172 4.84979 6.35911 4.70788L9.74785 1.31915Z"
      fill={color}
    />
  </svg>
);

export const LargeArrowLeft: React.FC<SvgProps> = ({
  height = "16",
  width = "16",
  color = "currentColor",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={color}
        d="M14.25 7.281a.75.75 0 0 1 0 1.5H3.38l2.474 2.77a.75.75 0 1 1-1.152.96l-3.5-4a.75.75 0 0 1 0-.96l3.5-4a.75.75 0 0 1 1.152.96L3.38 7.282H14.25z"
      />
    </g>
  </svg>
);

export const LargeArrowRight: React.FC<SvgProps> = ({
  height = "16",
  width = "16",
  color = "currentColor",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: "rotate(180deg)" }}
    {...rest}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={color}
        d="M14.25 7.281a.75.75 0 0 1 0 1.5H3.38l2.474 2.77a.75.75 0 1 1-1.152.96l-3.5-4a.75.75 0 0 1 0-.96l3.5-4a.75.75 0 0 1 1.152.96L3.38 7.282H14.25z"
      />
    </g>
  </svg>
);

export const Plus: React.FC<SvgProps> = ({
  height = "16",
  width = "16",
  color = "currentColor",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g id="plus" fill="none" fillRule="evenodd">
      <path
        d="M15 8a.84.84 0 0 1-.84.84H1.84a.84.84 0 0 1 0-1.68h12.32A.84.84 0 0 1 15 8z"
        fill={color}
      />
      <path
        d="M8 15a.84.84 0 0 1-.84-.84V1.84a.84.84 0 1 1 1.68 0v12.32A.84.84 0 0 1 8 15z"
        fill={color}
      />
    </g>
  </svg>
);

export const Minus: React.FC<SvgProps> = ({
  height = "16",
  width = "16",
  color = "currentColor",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g id="minus" fill="none" fillRule="evenodd">
      <path
        d="M15 8a.84.84 0 0 1-.84.84H1.84a.84.84 0 0 1 0-1.68h12.32A.84.84 0 0 1 15 8z"
        fill={color}
      />
    </g>
  </svg>
);

export const SmallArrowUp: React.FC<SvgProps> = ({
  height = "16",
  width = "16",
  color = "currentColor",
  ...rest
}) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
        <stop stopColor={color} stopOpacity="0.85" offset="0%"></stop>
        <stop stopColor={color} offset="100%"></stop>
      </linearGradient>
      <path
        d="M8.50003057,3.75 C8.50003057,3.335786 8.16424057,3 7.75003057,3 C7.33582057,3 7.00003057,3.335786 7.00003057,3.75 L7.00003057,10.64873 L5.23016057,9.17384 C4.91194957,8.90866 4.43902557,8.95166 4.17385257,9.26987 C3.90867987,9.58807 3.95167287,10.061 4.26988057,10.32617 L7.26988057,12.82617 C7.54801057,13.0579 7.95202057,13.0579 8.23016057,12.82617 L11.2301606,10.32617 C11.5483606,10.061 11.5913606,9.58807 11.3261806,9.26987 C11.0610106,8.95166 10.5880906,8.90866 10.2698806,9.17384 L8.50003057,10.64871 L8.50003057,3.75 Z"
        id="path-2"
      ></path>
    </defs>
    <g
      id="arrow-up"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Path"
        transform="translate(7.750018, 7.999984) rotate(180.000000) translate(-7.750018, -7.999984) "
      >
        <use fill={color} href="#path-2"></use>
        <use
          fillOpacity="0.85"
          fill="url(#linearGradient-1)"
          href="#path-2"
        ></use>
      </g>
    </g>
  </svg>
);

export const ThumbsUp: React.FC<SvgProps> = ({
  height = "24",
  width = "24",
  color = "currentColor",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29398 20.4966C4.56534 20.4966 4 19.8827 4 19.1539V12.3847C4 11.6559 4.56534 11.042 5.29398 11.042H8.12364L10.8534 4.92738C10.9558 4.69809 11.1677 4.54023 11.4114 4.50434L11.5175 4.49658C12.3273 4.49658 13.0978 4.85402 13.6571 5.48039C14.2015 6.09009 14.5034 6.90649 14.5034 7.7535L14.5027 8.92295L18.1434 8.92346C18.6445 8.92346 19.1173 9.13931 19.4618 9.51188L19.5612 9.62829C19.8955 10.0523 20.0479 10.6054 19.9868 11.1531L19.1398 18.742C19.0297 19.7286 18.2529 20.4966 17.2964 20.4966H8.69422H5.29398ZM11.9545 6.02658L9.41727 11.7111L9.42149 11.7693L9.42091 19.042H17.2964C17.4587 19.042 17.6222 18.8982 17.6784 18.6701L17.6942 18.5807L18.5412 10.9918C18.5604 10.8194 18.5134 10.6486 18.4189 10.5287C18.3398 10.4284 18.2401 10.378 18.1434 10.378H13.7761C13.3745 10.378 13.0488 10.0524 13.0488 9.65073V7.7535C13.0488 7.2587 12.8749 6.78825 12.5721 6.44915C12.4281 6.28794 12.2615 6.16343 12.0824 6.07923L11.9545 6.02658ZM7.96636 12.4966H5.45455V19.042H7.96636V12.4966Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29398 20.4966C4.56534 20.4966 4 19.8827 4 19.1539V12.3847C4 11.6559 4.56534 11.042 5.29398 11.042H8.12364L10.8534 4.92738C10.9558 4.69809 11.1677 4.54023 11.4114 4.50434L11.5175 4.49658C12.3273 4.49658 13.0978 4.85402 13.6571 5.48039C14.2015 6.09009 14.5034 6.90649 14.5034 7.7535L14.5027 8.92295L18.1434 8.92346C18.6445 8.92346 19.1173 9.13931 19.4618 9.51188L19.5612 9.62829C19.8955 10.0523 20.0479 10.6054 19.9868 11.1531L19.1398 18.742C19.0297 19.7286 18.2529 20.4966 17.2964 20.4966H8.69422H5.29398ZM11.9545 6.02658L9.41727 11.7111L9.42149 11.7693L9.42091 19.042H17.2964C17.4587 19.042 17.6222 18.8982 17.6784 18.6701L17.6942 18.5807L18.5412 10.9918C18.5604 10.8194 18.5134 10.6486 18.4189 10.5287C18.3398 10.4284 18.2401 10.378 18.1434 10.378H13.7761C13.3745 10.378 13.0488 10.0524 13.0488 9.65073V7.7535C13.0488 7.2587 12.8749 6.78825 12.5721 6.44915C12.4281 6.28794 12.2615 6.16343 12.0824 6.07923L11.9545 6.02658ZM7.96636 12.4966H5.45455V19.042H7.96636V12.4966Z"
      fill={color}
    />
  </svg>
);

export const TopCaret: React.FC<SvgProps> = ({
  height = "8",
  width = "16",
  color = "currentColor",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 8"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <defs>
      <clipPath id="i0">
        <path d="M9.3912777,0.590799928 L11.8266759,3.22760605 C12.8648163,4.35160464 14.3915663,5 16,5 L0,5 C0.0295978076,5 0.0591679461,4.99978044 0.0887078805,4.99934241 C1.66434944,4.97597796 3.15405745,4.33102228 4.17311097,3.22783933 L6.60912844,0.590718281 C7.33672461,-0.196938863 8.66373617,-0.196900538 9.3912777,0.590799928 Z"></path>
      </clipPath>
      <clipPath id="i1">
        <path d="M17,-1.99999948 L17,7 L-1,7 L-1,-1.99999948 L17,-1.99999948 Z M9.3912777,0.590799928 C8.66373617,-0.196900538 7.33672461,-0.196938863 6.60912844,0.590718281 L4.17311097,3.22783933 C3.15405745,4.33102228 1.66434944,4.97597796 0.0887078805,4.99934241 C0.0591679461,4.99978044 0.0295978076,5 0,5 L16,5 C14.3915663,5 12.8648163,4.35160464 11.8266759,3.22760605 Z"></path>
      </clipPath>
      <clipPath id="i2">
        <path d="M16,0 L16,2 L0,2 L0,0 L16,0 Z"></path>
      </clipPath>
    </defs>
    <g transform="translate(-239.0 1.0)">
      <g transform="translate(239.0 0.0)">
        <g clipPath="url(#i0)">
          <polygon
            points="0,1.11022302e-16 16,1.11022302e-16 16,5 0,5 0,1.11022302e-16"
            stroke="none"
            fill="#FFFFFF"
          ></polygon>
        </g>
        <g clipPath="url(#i1)">
          <path
            d="M16,5 L0,5 C0.0295978076,5 0.0591679461,4.99978044 0.0887078805,4.99934241 C1.66434944,4.97597796 3.15405745,4.33102228 4.17311097,3.22783933 L6.60912844,0.590718281 C7.33672461,-0.196938863 8.66373617,-0.196900538 9.3912777,0.590799928 L11.8266759,3.22760605 C12.8648163,4.35160464 14.3915663,5 16,5 Z"
            stroke="#DFDFDF"
            strokeWidth="2"
            fill="none"
            strokeMiterlimit="5"
          ></path>
        </g>
        <g transform="translate(0.0 5.0)">
          <g clipPath="url(#i2)">
            <polygon
              points="0,0 16,0 16,2 0,2 0,0"
              stroke="none"
              fill="#FFFFFF"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Refresh: React.FC<SvgProps> = ({
  height = "16",
  width = "16",
  color = "currentColor",
  ...rest
}) => (
  <svg
    fill={color}
    height={height}
    width={width}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 489.645 489.645"
    {...rest}
  >
    <g strokeWidth="0"></g>
    <g strokeLinecap="round" strokeLinejoin="round"></g>
    <g>
      <g>
        <path d="M460.656,132.911c-58.7-122.1-212.2-166.5-331.8-104.1c-9.4,5.2-13.5,16.6-8.3,27c5.2,9.4,16.6,13.5,27,8.3 c99.9-52,227.4-14.9,276.7,86.3c65.4,134.3-19,236.7-87.4,274.6c-93.1,51.7-211.2,17.4-267.6-70.7l69.3,14.5 c10.4,2.1,21.8-4.2,23.9-15.6c2.1-10.4-4.2-21.8-15.6-23.9l-122.8-25c-20.6-2-25,16.6-23.9,22.9l15.6,123.8 c1,10.4,9.4,17.7,19.8,17.7c12.8,0,20.8-12.5,19.8-23.9l-6-50.5c57.4,70.8,170.3,131.2,307.4,68.2 C414.856,432.511,548.256,314.811,460.656,132.911z"></path>{" "}
      </g>
    </g>
  </svg>
);

export const Checkmark: React.FC<SvgProps> = ({
  height = "10",
  width = "10",
  color,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      id="checkmark"
      d="M1.5 5L4 7.5L8.5 2"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Filter: React.FC<SvgProps> = ({
  height = "16",
  width = "16",
  color = "currentColor",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path id="filter" d="M2 2H14L9 8V12L7 13V8L2 2Z" fill={color} />
  </svg>
);
